import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import zh from 'vee-validate/dist/locale/zh_CN' // 引入中文文件
import store from '../store/store'
Validator.addLocale(zh)
const config = {
    delay: 0,
    locale: store.state.locale,
    fieldsBagName: 'fields'
}
console.log('config', config)
Vue.use(VeeValidate, config)

// 自定义validate
const dictionary = {
    zh: {
        messages: {
            required: (field) => '*請' + field, //请
            numeric: (field) => field + '必須是數值.', //必须为数值
            url: () => '请输入正确格式的服务器地址',
            ip: () => '请输入正确的IP地址',
            yn: () => field
        },
        attributes: {
            isSee: '必須打鉤.',
            carModelName: '選擇車型.',
            carStyleName: 'Selec Car Type.',
            mileage: '填寫里數.',
            color_id: '選擇車身顏色.',
            license_no: 'Invalid VIN at least 17 bits',

            userName: '填寫姓名.',
            userTitle: '填寫稱謂.',
            userLastname: '填寫姓氏.',
            userFirstname: '填寫名字.',

            mobile: '填寫手提電話.',
            emailAdd: '填寫電郵.',
            contact_time: '選擇聯絡時段.',
            showroom: '選擇指定展覽中心.',

            enquiry: '選擇訊息.',
            Privacy_yn: '請確認已閱讀條款及細則.'
        }
    }
}
Validator.updateDictionary(dictionary)


// 邮箱
Validator.extend('email', {
    messages: {
        zh: field => '郵箱格式不正確.',
        en: field => 'Incorrect mailbox format.'
    },
    validate: value => {
        return /^[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?$/.test(value)
    }
})

// 用户协议
Validator.extend('seeyn', {
    messages: {
        zh: field => '*確認已閱讀條款及細則.',
        en: field => '*Please confirm you have read the terms and conditions.'
    },
    validate: value => {
        console.log('config', value)
        console.log('value', value)
        return /^(true)$/.test(value)
    }
})

// 车型 
// Validator.extend('modelselect', {
//   messages: {
//       zh: field => '请选择车型'
//   },
//   validate: value => {
//       return /^\S{6,18}$/.test(value)
//   }
// })

//不能包含I、O、Q车牌无效
Validator.extend('ioq', {
    messages: {
        zh: field => '車牌資料不正確，例如包括英文字母 I, O, Q.',
        en: field => 'Invalid Car Plate e.g. contains I, O, Q.'
    },
    validate: value => {
        return /^(?:(?![oiqOIQ])[a-zA-Z0-9])+$/gmi.test(value)
    }
})

//至少17位
Validator.extend('vim', {
    messages: {
        zh: field => '車輛登記號碼不正確，至少17位.',
        en: field => 'Invalid VIN at least 17 bits.'
    },
    validate: value => {
        return /^\w{17}$/.test(value)
    }
})


// WEBPACK FOOTER //
// ./src/untils/validate.js